import ExcelJS from 'exceljs';

export const exportToExcel = async (results, tabName) => {
  const workbook = new ExcelJS.Workbook();
  const sheetName = tabName.charAt(0).toUpperCase() + tabName.slice(1);
  const worksheet = workbook.addWorksheet(`${sheetName} Opportunities`);

  // Title row
  worksheet.getCell('A1').value = `Trend Hunters — ${sheetName} Report`;
  worksheet.getCell('A1').font = { bold: true, size: 14, color: { argb: 'FF1E293B' } };
  worksheet.mergeCells('A1:L1');

  // Date row
  const date = new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  worksheet.getCell('A2').value = `Generated: ${date}`;
  worksheet.getCell('A2').font = { size: 10, color: { argb: 'FF64748B' } };
  worksheet.mergeCells('A2:L2');

  // Disclaimer
  worksheet.getCell('A3').value = '* 12-Month Projection is a modelled estimate.';
  worksheet.getCell('A3').font = { italic: true, size: 9, color: { argb: 'FF94A3B8' } };
  worksheet.mergeCells('A3:L3');

  // Headers
  const headers = [
    'Name',
    'Opportunity Score',
    'Verdict',
    'Stage',
    '30-Day Growth %',
    '12-Month Projection',
    'Demand (0-10)',
    'Competition (0-10)',
    'Monetisation (0-10)',
    'Time Window',
    'Why Now',
    'Suggested Angle',
  ];
  worksheet.addRow(headers);

  const headerRow = worksheet.getRow(4);
  headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
  headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0F172A' } };
  headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  headerRow.height = 30;

  // Data rows
  results.forEach((item) => {
    const row = worksheet.addRow([
      item.name,
      item.opportunityScore,
      item.verdict,
      item.stage,
      `+${item.growth30d}%`,
      item.growthProjection12m,
      item.demandScore,
      item.competitionScore,
      item.monetisationScore,
      item.timeWindow,
      item.whyNow,
      item.suggestedAngle,
    ]);

    // Name bold
    row.getCell(1).font = { bold: true };
    row.getCell(1).alignment = { vertical: 'top', wrapText: true };

    // Score styling
    const scoreCell = row.getCell(2);
    scoreCell.font = { bold: true, size: 14 };
    scoreCell.alignment = { horizontal: 'center', vertical: 'middle' };

    // Verdict color
    const verdictCell = row.getCell(3);
    verdictCell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    verdictCell.alignment = { horizontal: 'center', vertical: 'middle' };
    if (item.verdict === 'BUY') {
      verdictCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF22C55E' } };
    } else if (item.verdict === 'WATCH') {
      verdictCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEAB308' } };
    } else {
      verdictCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEF4444' } };
    }

    // Stage
    row.getCell(4).alignment = { horizontal: 'center', vertical: 'middle' };
    row.getCell(4).font = { bold: true };

    // Growth color
    const growthCell = row.getCell(5);
    growthCell.alignment = { horizontal: 'center', vertical: 'middle' };
    growthCell.font = { bold: true, color: { argb: item.growth30d > 30 ? 'FF22C55E' : item.growth30d >= 10 ? 'FFEAB308' : 'FFEF4444' } };

    // Projection
    const projCell = row.getCell(6);
    projCell.alignment = { horizontal: 'center', vertical: 'middle' };

    // Score cells
    [7, 8, 9].forEach(col => {
      row.getCell(col).alignment = { horizontal: 'center', vertical: 'middle' };
      row.getCell(col).font = { bold: true };
    });

    // Time window
    row.getCell(10).alignment = { horizontal: 'center', vertical: 'middle' };

    // Text cells
    row.getCell(11).alignment = { vertical: 'top', wrapText: true };
    row.getCell(12).alignment = { vertical: 'top', wrapText: true };
  });

  // Column widths
  worksheet.getColumn(1).width = 25;
  worksheet.getColumn(2).width = 12;
  worksheet.getColumn(3).width = 10;
  worksheet.getColumn(4).width = 12;
  worksheet.getColumn(5).width = 14;
  worksheet.getColumn(6).width = 16;
  worksheet.getColumn(7).width = 12;
  worksheet.getColumn(8).width = 14;
  worksheet.getColumn(9).width = 14;
  worksheet.getColumn(10).width = 14;
  worksheet.getColumn(11).width = 40;
  worksheet.getColumn(12).width = 40;

  // Generate filename
  const dateStr = new Date().toISOString().split('T')[0];
  const filename = `Opportunity_Terminal_${sheetName}_${dateStr}.xlsx`;

  // Download
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
};
